enum ETypeOfPartnership {
	arbeitgeber = "Arbeitgeber", // firm -> Arbeitgeber
	haendler = "Haendler", // partner -> Haendler -> Radl-Händler
	all = "Alle",
}

export default ETypeOfPartnership;
